<style src="css/eBookWord.css" scoped></style>
<template>
  <div style="padding-top: 0.98rem; background: #fff">
    <topbar text="电子书"></topbar>
    <v-touch
      v-on:swipeleft="swiperleft"
      v-on:swiperight="swiperright"
      class="wrapper"
    >
      <div class="main" v-if="!end">
        <div class="title">{{ catalogName }}</div>
        <div class="content" v-html="list[index].content"></div>
        <div class="bottom">{{ index + 1 }}/{{ totalPage }}</div>
      </div>
      <div class="endBox" v-if="end">
        <img class="endImg" src="~assets/end.png" alt="" />
        <div class="endBtn" @click="back">返回电子书章节列表</div>
      </div>
    </v-touch>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      bookId: "",
      catalogId: "",
      totalPage: "",
      catalogName: "",
      index: 0,
      list: [],
      end: false,
      orderNo:''
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    back() {
        history.back()
    },
    to(id) {
      this.$router.push(`/jokeDetail?id=${id}`);
    },
    swiperleft() {
      //左划
      console.log(this.index)
      if (this.index < this.totalPage - 1) {
        this.index = this.index + 1;
      } else {
        this.end = true;
      }
    },
    swiperright() {

      //右滑
      if (this.index > 0) {
        this.index = this.index - 1;
      }
    },
    async getDetail() {
      let obj = {};
      obj.bookId = this.bookId;
      obj.catalogId = this.catalogId;
      obj.orderNo = this.orderNo;
      obj.companyId = localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "";
      let data = await getSources(
        "/bear-scale/api/scaleUserBook/getBookCatalog",
        obj
      );
      if (data.status === 0) {
        this.list = data.pageList;
        this.totalPage = data.totalPage;
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {},
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.bookId = this.$route.query.bookId;
    this.catalogId = this.$route.query.catalogId;
    this.catalogName = this.$route.query.catalogName;
    this.orderNo = this.$route.queryorderNo?this.$route.queryorderNo:''
    this.getDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/eBookWord.vue?614edb2e